export default "__VITE_ASSET__QbDDzihf__"